import ControlledTitleField from './ControlledTitleField';

export default ControlledTitleField;
